import { passwordChecks } from '../utils/passwordPolicy';

/** Under a new-password field: what the password needs, with each requirement ticked as it is met. */
function PasswordHint({ password }) {
  const typed = Boolean(password);
  return (
    <div className="small mt-1" aria-live="polite">
      <span className="text-muted">Needs: </span>
      {passwordChecks(password).map((c, i) => (
        <span key={c.label} className={typed ? (c.met ? 'text-success' : 'text-danger') : 'text-muted'}>
          {i > 0 && <span className="text-muted">, </span>}
          {typed && c.met && <i className="bi bi-check-lg me-1" />}
          {c.label}
        </span>
      ))}
    </div>
  );
}

export default PasswordHint;
